import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=a12df060&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=ts&"
export * from "./PromotionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=a12df060&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12df060",
  null
  
)

export default component.exports